import EventBus from '@assets/scripts/event-bus';
export default {
  data: function data() {
    return {
      searchInput: null,
      sortedItems: [],
      unwatchItems: null
    };
  },
  watch: {
    searchInput: function searchInput(newValue) {
      if (!newValue) {
        return;
      }

      this.sortedItems = this.sortBySearchInput(this.originalItems, newValue);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.unwatchItems = this.$watch('items', function (newItems) {
      if (newItems && newItems.length) {
        _this.originalItems = newItems;
        _this.sortedItems = _this.sortAlphabetically(newItems);

        _this.unwatchItems();
      }
    });

    if (this.originalItems && this.originalItems.length) {
      this.sortedItems = this.sortAlphabetically(this.originalItems);
    }

    EventBus.$on('autocomplete:update-sorting', this.sortOnRemoval);
  },
  methods: {
    handleSearchInput: function handleSearchInput(searchString) {
      if (!searchString || this.$refs.combobox.lazyValue && this.$refs.combobox.lazyValue.label && searchString === this.$refs.combobox.lazyValue.label || searchString === this.$refs.combobox.lazyValue) {
        this.sortedItems = this.sortAlphabetically(this.originalItems);
        this.searchInput = null;
        return;
      }

      this.searchInput = searchString;
    },
    sortOnRemoval: function sortOnRemoval() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.sortedItems = _this2.sortAlphabetically(_this2.originalItems);
      });
    },
    sortAlphabetically: function sortAlphabetically(items) {
      return this.prependSelected(items.sort(function (a, b) {
        var aVal = a.label ? a.label : a;
        var bVal = b.label ? b.label : b;

        if (aVal.toLowerCase() < bVal.toLowerCase()) {
          return -1;
        }

        if (aVal.toLowerCase() > bVal.toLowerCase()) {
          return 1;
        }

        return 0;
      }));
    },
    sortBySearchInput: function sortBySearchInput(items, searchInput) {
      var _this3 = this;

      var searchLength = searchInput.length;
      return this.prependSelected(items.sort(function (a, b) {
        var aVal = a.label ? a.label : a;
        var bVal = b.label ? b.label : b;

        if (aVal.substring(0, searchLength).toLowerCase() === _this3.searchInput.toLowerCase()) {
          return -1;
        }

        if (bVal.substring(0, searchLength).toLowerCase() === _this3.searchInput.toLowerCase()) {
          return 1;
        }

        return 0;
      }));
    },
    prependSelected: function prependSelected(items) {
      if (!this.$refs.combobox || !this.bind.multiple) {
        return items;
      }

      var value = this.$refs.combobox.lazyValue;

      if (!value || !value.length) {
        return items;
      }

      return items.sort(function (a, b) {
        if (value.some(function (v) {
          return v.value === a.value;
        }) && value.some(function (v) {
          return v.value === b.value;
        })) {
          return a.label < b.label ? -1 : 1;
        }

        if (value.some(function (v) {
          return v.value === a.value;
        })) {
          return -1;
        }

        if (!value.some(function (v) {
          return v.value === b.value;
        })) {
          return 1;
        }

        return 0;
      });
    }
  }
};